/* ============================================================================
   NEOGEN — CONTACT page behaviour (/pages/contact)
   ----------------------------------------------------------------------------
   Ported 2026-07-22 (Fable 5) from the contact mockup's script, KEEPING ONLY
   the phone-required enhancement. The mockup's demo client-side validation +
   fake success panel are deliberately NOT ported: the real
   {% form 'contact' %} posts server-side and the section renders
   form.posted_successfully? / form.errors on the redirected page. Native
   browser validation covers the required fields.

   Phone becomes REQUIRED when Phone or SMS is the chosen contact method
   (Email → optional). The .is-required class drives the CSS (warm-red --req
   asterisk fades IN, "optional" tag fades OUT — micro-interaction 4);
   required/aria-required are set in lockstep so the visual signal and the
   validation constraint never diverge. No hard JS dependency: without JS the
   field is simply visible + optional and nothing breaks.
   ============================================================================ */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var phoneField = document.getElementById('ContactPhoneField');
    var phoneInput = document.getElementById('ContactPhone');
    var methodRadios = form.querySelectorAll('input[name="contact[Contact method]"]');
    if (phoneField && phoneInput && methodRadios.length) {
      var currentMethod = function () {
        var v = 'Email';
        methodRadios.forEach(function (r) { if (r.checked) v = r.value; });
        return v;
      };
      var syncPhone = function () {
        var needsPhone = currentMethod() !== 'Email';
        phoneField.classList.toggle('is-muted', !needsPhone);
        phoneField.classList.toggle('is-required', needsPhone);
        if (needsPhone) {
          phoneInput.setAttribute('required', '');
          phoneInput.setAttribute('aria-required', 'true');
        } else {
          phoneInput.removeAttribute('required');
          phoneInput.removeAttribute('aria-required');
        }
      };
      methodRadios.forEach(function (r) { r.addEventListener('change', syncPhone); });
      syncPhone();
    }

    /* After a server-side POST (success or errors), move focus to the status
       block so the outcome is announced and visible. */
    var status = form.querySelector('[data-contact-status]');
    if (status && window.location.hash === '#ContactForm') {
      status.focus({ preventScroll: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
